import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaCalendarAlt, FaMapMarkerAlt, FaArrowLeft, FaBuilding, FaClock } from 'react-icons/fa';
import { useTheme } from '../../contexts/ThemeContext';
import projectsData from './ProjectData';
import './Projects.css';

const ProjectDetails = () => {
  const { id } = useParams();
  const { theme } = useTheme();
  const [isLoading, setIsLoading] = useState(true);

  const project = projectsData.find((project) => project.id === parseInt(id));

  useEffect(() => {
    // Simulate loading for smooth transition
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="project-details-loading">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (!project) {
    return (
      <div className="project-not-found">
        <div className="container">
          <div className="not-found-content">
            <h2>Project Not Found</h2>
            <p>The project you're looking for doesn't exist.</p>
            <Link to="/projects" className="back-to-projects-btn">
              <FaArrowLeft /> Back to Projects
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`project-details-container`}>
      {/* Hero Section */}
      <div className="project-hero-section">
        <div className="hero-background"></div>
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="hero-content">
            <div className="breadcrumb">
              <Link to="/projects" className="breadcrumb-link">
                Projects
              </Link>
              <span className="breadcrumb-separator">/</span>
              <span className="breadcrumb-current">{project.title}</span>
            </div>
            <h1 className="project-title">{project.title}</h1>
            <div className="project-meta">
                    {project.year &&
              <div className="meta-item">
                <FaClock className="meta-icon" />
                 <span>Year : {project.year}</span>
              </div>
}
              {/* {project.startDate && 
              <div className="meta-item">
                <FaCalendarAlt className="meta-icon" />
                <span>Start: {project.startDate}</span>
              </div>
}
              {project.endDate &&
              <div className="meta-item">
                <FaClock className="meta-icon" />
                 <span>End: {project.endDate}</span>
              </div>
              } */}
              {project.type &&
              <div className="meta-item">
                <FaBuilding className="meta-icon" />
                 <span>{project.type}</span>
              </div>
              }
            </div>
          </div>
        </div>
      </div>

      {/* Project Content */}
      <div className="project-content-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="project-description">
                <h2 className="section-title">Project Overview</h2>
                <div className="description-content">
                  <p className="description-text">{project.description1}</p>
                  {project.description2 && (
                    <p className="description-text">{project.description2}</p>
                  )}
                </div>
              </div>

              {/* Project Media */}
              <div className="project-media">
                <h2 className="section-title">Project {project.video ? 'Video' : 'Gallery'}</h2>
                {project.video ? (
                  <div className="video-container" data-aos="fade-up">
                    <video 
                      controls
                      muted 
                      className="project-video"
                      poster={project.image?.[0] || undefined}
                      style={{ width: '100%', height: '500px', objectFit: 'cover' }}
                    >
                      <source src={project.video} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                ) : project.image && project.image.length > 0 ? (
                  <div className="gallery-grid">
                    {project.image.map((image, i) => (
                      <div key={i} className="gallery-item" data-aos="fade-up" data-aos-delay={i * 100}>
                        <div className="image-container">
                          <img
                            src={image}
                            alt={`${project.title} - Image ${i + 1}`}
                            className="gallery-image"
                            loading="lazy"
                          />
                          <div className="image-overlay">
                            <span className="image-number">{i + 1}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>
            </div>

            <div className="col-lg-4">
              <div className="project-sidebar">
                <div className="project-info-card">
                  <h3 className="card-title">Project Information</h3>
                  <div className="info-list">
                    <div className="info-item">
                      <span className="info-label">Project Type:</span>
                      <span className="info-value">{project.type}</span>
                    </div>
                    {project.year && (
                    <div className="info-item">
                      <span className="info-label">Year:</span>
                      <span className="info-value">{project.year}</span>
                    </div>
                    )}
                    {/* {project.endDate && (
                    <div className="info-item">
                      <span className="info-label">End Date:</span>
                      <span className="info-value">{project.endDate}</span>
                    </div>
                    )} */}
                    <div className="info-item">
                      <span className="info-label">Status:</span>
                      <span className="info-value status-completed">Completed</span>
                    </div>
                  </div>
                </div>
                {project.features && (
                  <div className="project-features-card">
                    <h3 className="card-title">Key Features</h3>
                    <ul className="features-list">
                      {project.features.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                </div>
                )}

                <div className="back-to-projects">
                  <Link to="/projects" className="back-btn">
                    <FaArrowLeft className="back-icon" />
                    Back to All Projects
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetails;
